import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./firebase";
import axios from "./http";

createApp(App).use(router).provide("axios", axios).mount("#app");
